(function () {
  if (window.__imInfopanel) return;
  window.__imInfopanel = true;

  var panel, overlay, body, lastFocus, lukkTimer, pageWrap;

  function harInnhold(d) {
    var k = d.querySelector('.details-content');
    return !!(k && (k.textContent.trim() !== '' || k.querySelector('img, table')));
  }

  /* Rader uten innhold (typisk tom produktbeskrivelse) skjules på siden. */
  function merkTomme() {
    document.querySelectorAll('.product-details .accordion details.details').forEach(function (d) {
      if (!harInnhold(d)) d.classList.add('im-ip-tom');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', merkTomme);
  else merkTomme();

  function synlige(fra) {
    var rot = (fra && fra.closest('.product-details')) || document;
    var rader = rot.querySelectorAll('.product-details .accordion details.details');
    return Array.prototype.filter.call(rader, function (d) {
      return harInnhold(d) && getComputedStyle(d).display !== 'none' && d.offsetParent !== null;
    });
  }

  function fokuserbare() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
  }

  function tittel(d) {
    var s = d.querySelector('summary');
    var t = s ? s.cloneNode(true) : null;
    if (!t) return '';
    t.querySelectorAll('.svg-wrapper, svg, img').forEach(function (n) { n.remove(); });
    return t.textContent.trim();
  }

  function bygg() {
    overlay = document.createElement('div');
    overlay.className = 'im-ip-overlay';
    overlay.hidden = true;
    panel = document.createElement('aside');
    panel.className = 'im-ip-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
        panel.tabIndex = -1;
    panel.hidden = true;
    panel.innerHTML = '<div class="im-ip-head"><button type="button" class="im-ip-close" aria-label="Lukk">&times;</button></div><div class="im-ip-body"></div>';
    body = panel.querySelector('.im-ip-body');
    document.body.appendChild(overlay);
    document.body.appendChild(panel);
    overlay.addEventListener('click', lukk);
    panel.querySelector('.im-ip-close').addEventListener('click', lukk);
    document.addEventListener('keydown', function (e) {
      if (!erApen()) return;
      if (e.key === 'Escape') { lukk(); return; }
      if (e.key === 'Tab') {
        var f = fokuserbare();
        if (!f.length) { e.preventDefault(); return; }
        var forste = f[0], siste = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === forste || document.activeElement === panel)) { e.preventDefault(); siste.focus(); }
        else if (!e.shiftKey && document.activeElement === siste) { e.preventDefault(); forste.focus(); }
      }
    });
  }

  function fyll(d) {
    var h = document.createElement('h2');
    h.className = 'im-ip-tittel';
    h.id = 'im-ip-tittel';
    h.textContent = tittel(d);
    var innhold = document.createElement('div');
    innhold.className = 'im-ip-innhold';
    var kilde = d.querySelector('.details-content');
    if (kilde) innhold.appendChild(kilde.cloneNode(true));
    body.appendChild(h);
    body.appendChild(innhold);
    panel.setAttribute('aria-labelledby', 'im-ip-tittel');
  }

  function erApen() { return panel && panel.classList.contains('er-apen'); }

  function apne(valgt) {
    if (!panel) bygg();
    clearTimeout(lukkTimer);
    lastFocus = document.activeElement;
    body.innerHTML = '';
    fyll(valgt);
    pageWrap = document.querySelector('.page-wrapper');
    if (pageWrap) pageWrap.inert = true;
    overlay.hidden = false;
    panel.hidden = false;
    document.documentElement.classList.add('im-ip-laast');
    requestAnimationFrame(function () {
      overlay.classList.add('er-apen');
      panel.classList.add('er-apen');
      panel.focus({ preventScroll: true });
    });
  }

  function lukk() {
    if (!erApen()) return;
    overlay.classList.remove('er-apen');
    panel.classList.remove('er-apen');
    document.documentElement.classList.remove('im-ip-laast');
    if (pageWrap) pageWrap.inert = false;
    clearTimeout(lukkTimer);
    lukkTimer = setTimeout(function () {
      if (!erApen()) { overlay.hidden = true; panel.hidden = true; }
    }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* Fang klikket på raden før temaets trekkspill (capture-fasen). */
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.product-details .accordion summary');
    if (!s) return;
    var d = s.closest('details.details');
    if (!d) return;
    e.preventDefault();
    e.stopPropagation();
    if (d.open) d.open = false;
    if (!harInnhold(d)) return;
    apne(d);
  }, true);
})();
